<template>
  <div>
    <div>
      <CRow>
        <CCol sm="12">
          <CCard>
            <CCardHeader
              class="d-flex justify-content-between align-items-center"
            >
              <CCardTitle
                style="
                  display: inline-block;
                  margin-top: 8px;
                  margin-bottom: 0px;
                "
                ><h3>{{ concurso.nombre }}</h3></CCardTitle
              >

              <div>
                <CButton
                  color="danger"
                  v-if="concurso.idEstadoConcurso == 2"
                  style="display: inline; margin-right: 10px"
                  @click="showCerrarConcurso = true"
                  >Cerrar concurso</CButton
                >

                <CButton
                  style="
                    display: inline-block;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                  color="secondary"
                  @click="returnPage"
                  >Volver</CButton
                >
              </div>
            </CCardHeader>
            <CCardBody>
              <CCard>
                <CCardHeader>
                  <CRow
                    ><CCol
                      ><b>Número de expediente:</b>
                      {{ concurso.numeroExpediente }}</CCol
                    ></CRow
                  >
                </CCardHeader>
              </CCard>

              <CRow>
                <CCol sm="4"
                  ><CCard class="status-card"
                    ><CCardHeader
                      ><b
                        style="
                          display: inline-block;
                          margin-top: 6px;
                          margin-bottom: 0px;
                        "
                        >Cálculo de bajas</b
                      >
                      <h3 style="display: inline-block; float: right">
                        <CBadge :color="getBadge(concurso.calculoBaja)">{{
                          concurso.calculoBaja == 1 ? "Calculado" : "Pendiente"
                        }}</CBadge>
                      </h3> </CCardHeader
                    ><CCardBody
                      class="d-flex justify-content-between align-items-center"
                    >
                      <CRow>
                        <CCol sm="12">
                          <b>Fecha del último cálculo de bajas: </b>
                          {{
                            concurso.ultimoCalculoBaja
                              ? formatDate(new Date(concurso.ultimoCalculoBaja))
                              : "Sin fecha"
                          }}
                        </CCol>
                        <CCol sm="12">
                          <b
                            style="color: green"
                            v-if="
                              concurso.calculoBaja == 1 &&
                              listaLotesBajas.length == 0
                            "
                            ><br />No se ha detectado ningún lote que requiera
                            atención.</b
                          >
                          <b
                            style="color: red"
                            v-if="
                              concurso.calculoBaja == 1 &&
                              listaLotesBajas.length > 0
                            "
                            ><br />Se han encontrado
                            {{ listaLotesBajas.length }} lotes con bajas que
                            requieren atención.</b
                          >
                        </CCol></CRow
                      > </CCardBody
                    ><CCardFooter v-if="concurso.idEstadoConcurso != 2"
                      ><CButton
                        style="float: right; display: inline-block"
                        color="info"
                        @click="detectarBajas"
                        >Calcular bajas</CButton
                      ></CCardFooter
                    ></CCard
                  ></CCol
                >

                <CCol sm="4"
                  ><CCard class="status-card"
                    ><CCardHeader
                      ><b
                        style="
                          display: inline-block;
                          margin-top: 6px;
                          margin-bottom: 0px;
                        "
                        >Cálculo de puntos</b
                      >
                      <h3 style="display: inline-block; float: right">
                        <CBadge :color="getBadge(concurso.calculoPuntos)">{{
                          concurso.calculoPuntos == 1
                            ? "Calculado"
                            : "Pendiente"
                        }}</CBadge>
                      </h3> </CCardHeader
                    ><CCardBody
                      class="d-flex justify-content-between align-items-center"
                    >
                      <CRow>
                        <CCol sm="12">
                          <b>Fecha del cálculo de puntos: </b>
                          {{
                            concurso.ultimoCalculoPuntos
                              ? formatDate(
                                  new Date(concurso.ultimoCalculoPuntos)
                                )
                              : "Sin fecha"
                          }}
                        </CCol>
                        <CCol sm="12">
                          <b
                            style="color: green"
                            v-if="
                              concurso.calculoPuntos == 1 &&
                              concurso.lotesConEmpates.length == 0
                            "
                            ><br />No se ha detectado ningún lote que requiera
                            atención.</b
                          >
                          <b
                            style="color: red"
                            v-if="
                              concurso.calculoPuntos == 1 &&
                              concurso.lotesConEmpates.length > 0
                            "
                            ><br />Se han encontrado
                            {{ concurso.lotesConEmpates.length }} lotes con
                            empates que requieren atención.</b
                          >
                        </CCol>
                      </CRow> </CCardBody
                    ><CCardFooter
                      v-if="
                        concurso.calculoBaja == 1 &&
                        concurso.idEstadoConcurso != 2
                      "
                    >
                      <CButton
                        style="float: right; display: inline-block"
                        color="info"
                        v-if="!(listaLotesBajas.length > 0)"
                        @click="calcularPuntos"
                        >Calcular puntos</CButton
                      ></CCardFooter
                    ></CCard
                  ></CCol
                >

                <CCol sm="4">
                  <CCard class="status-card"
                    ><CCardHeader
                      ><b
                        style="
                          display: inline-block;
                          margin-top: 6px;
                          margin-bottom: 0px;
                        "
                        >Estado del concurso</b
                      >
                      <h3 style="display: inline-block; float: right">
                        <CBadge
                          :color="getBadgeResolucion(concurso.estadoConcurso)"
                          >{{ concurso.estadoConcurso }}</CBadge
                        >
                      </h3>
                    </CCardHeader>
                    <CCardBody
                      class="d-flex justify-content-between align-items-center"
                      ><b>Fecha de resolución del concurso: </b>
                      {{
                        concurso.ultimoCalculoResolucion
                          ? formatDate(
                              new Date(concurso.ultimoCalculoResolucion)
                            )
                          : "Sin fecha"
                      }}</CCardBody
                    ><CCardFooter
                      v-if="
                        concurso.calculoPuntos == 1 &&
                        concurso.calculoBaja == 1 &&
                        concurso.idEstadoConcurso != 2
                      "
                      >
                      <div v-if="concurso.lotesConEmpates">
                        <CButton
                        style="float: right; display: inline-block"
                        color="info"
                        v-if="(concurso.lotesConEmpates.length == 0) || concurso.lotesConEmpates.length > 0 && !empatesSignificativos"
                        @click="resConcurso"
                        >Resolver concurso</CButton
                      >
                      <CButton
                        style="float: right; display: inline-block"
                        color="warning"
                        v-if="(concurso.lotesConEmpates.length > 0) && empatesSignificativos"
                        @click="simConcursoModal = true"
                        >Verificar empates</CButton
                      ></div>
                      </CCardFooter
                    ></CCard
                  >
                </CCol>
              </CRow>

              <CCard v-if="listaLotesConIncidencias.length > 0">
                <CCardHeader>
                  <CIcon name="cil-warning" style="color: orange" />
                  <b>Lotes con incidencias</b>
                </CCardHeader>
                <CCardBody>
                  <CDataTable
                    hover
                    striped
                    :items-per-page="10"
                    :items="listaLotesConIncidencias"
                    :fields="camposLotesIncidencias"
                    sorter
                    pagination
                  >
                    <template #descripcionEstadoLote="{ item }">
                      <td>
                        <CBadge :color="getBadgeLote(item.idEstado)">{{
                          item.descripcionEstadoLote
                        }}</CBadge>
                      </td>
                    </template>
                    <template #acciones="{ item }">
                      <CButton
                        color="secondary"
                        size="sm"
                        style="margin-top: 10px"
                        @click="verDetallesLote(item.id)"
                        >Ver lote</CButton
                      >
                    </template>
                  </CDataTable>
                </CCardBody>
              </CCard>

              <CCard>
                <CCardHeader>
                  <b>Descripción:</b>
                </CCardHeader>
                <CCardBody>
                  <CRow
                    ><CCol>{{ concurso.descripcion }}</CCol></CRow
                  ></CCardBody
                >
              </CCard>

              <CCard>
                <CCardHeader>
                  <b>Comentarios:</b>
                </CCardHeader>
                <CCardBody>
                  <CRow
                    ><CCol>{{
                      concurso.comentarios
                        ? concurso.comentarios
                        : "Sin comentarios."
                    }}</CCol></CRow
                  ></CCardBody
                >
              </CCard>

              <CCard>
                <CCardHeader
                  class="d-flex justify-content-between align-items-center"
                >
                  <b style="display: inline-block">Criterios de evaluación:</b>
                  <CustomExport
                    style="display: inline-block"
                    :lista="concurso.criteriosEvaluacion"
                    :fields="camposCritEval"
                    :name="'Criterios de Evaluación - ' + concurso.nombre"
                  ></CustomExport>
                </CCardHeader>
                <CCardBody>
                  <div style="display: inline-block; margin-bottom: 20px">
                    <b>Modelo de cálculo:</b> {{ concurso.nombreCalculo }}
                  </div>
                  <CDataTable
                    hover
                    striped
                    :items-per-page="10"
                    :items="concurso.criteriosEvaluacion"
                    :fields="camposCritEval"
                    sorter
                    pagination
                  >
                    <template #peso="{ item }">
                      <td>{{ item.peso ? item.peso : 0 }} %</td>
                    </template></CDataTable
                  >
                </CCardBody>
              </CCard>

              <CCard>
                <CCardHeader>
                  <b>Subexpedientes:</b>
                </CCardHeader>
                <CListGroup v-if="!cargandoExpedientes" flush>
                  <CListGroupItem
                    style="display: block !important; overflow-x: auto"
                    v-for="subexpediente in concurso.expedientes"
                    :key="subexpediente.id"
                  >
                    <CRow>
                      <CCol
                        class="d-flex justify-content-between align-items-center"
                      >
                        {{ subexpediente.nombre }}
                        <CButton
                          :disabled="subexpediente.lotes.length == 0"
                          size="sm"
                          @click="mostrarLotes(subexpediente)"
                          :color="
                            subexpediente.lotes.length > 0 ? 'info' : 'warning'
                          "
                          >{{
                            subexpediente.lotes.length > 0
                              ? subexpediente.mostrarLotes
                                ? "Ocultar lotes"
                                : "Mostrar lotes"
                              : "Sin lotes"
                          }}</CButton
                        >
                      </CCol></CRow
                    >

                    <CRow>
                      <CCol>
                        <CCollapse
                          :show="
                            subexpediente.mostrarLotes &&
                            subexpediente.lotes.length > 0
                          "
                          :duration="400"
                        >
                          <br />
                          <CDataTable
                            hover
                            sort
                            striped
                            :items="subexpediente.lotes"
                            :fields="camposSubexpediente"
                            :items-per-page="10"
                            sorter
                            pagination
                          >
                            <template #descripcionEstadoLote="{ item }">
                              <td>
                                <CBadge
                                  :color="
                                    getBadgeLote(item.descripcionEstadoLote)
                                  "
                                  >{{ item.descripcionEstadoLote }}</CBadge
                                >
                              </td>
                            </template>
                            <template #precioDiaSinIVA="{ item }">
                              <td>
                                {{
                                  item.precioDiaSinIVA
                                    ? item.precioDiaSinIVA
                                    : 0
                                }}
                                €
                              </td>
                            </template>
                            <template #precioDiaConIVA="{ item }">
                              <td>
                                {{
                                  item.precioDiaConIVA
                                    ? item.precioDiaConIVA
                                    : 0
                                }}
                                €
                              </td>
                            </template>
                            <template #presupuestoLicitacionSinIVA="{ item }">
                              <td>
                                {{
                                  item.presupuestoLicitacionSinIVA
                                    ? item.presupuestoLicitacionSinIVA
                                    : 0
                                }}
                                €
                              </td>
                            </template>
                            <template #presupuestoLicitacionConIVA="{ item }">
                              <td>
                                {{
                                  item.presupuestoLicitacionConIVA
                                    ? item.presupuestoLicitacionConIVA
                                    : 0
                                }}
                                €
                              </td>
                            </template>
                            <template #presupuestoImpuestos="{ item }">
                              <td>
                                {{
                                  item.presupuestoImpuestos
                                    ? item.presupuestoImpuestos
                                    : 0
                                }}
                                €
                              </td>
                            </template>
                            <template #valorContratoSinIVA="{ item }">
                              <td>
                                {{
                                  item.valorContratoSinIVA
                                    ? Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(item.valorContratoSinIVA)
                                    : 0
                                }}
                                
                              </td>
                            </template>
                            <template #acciones="{ item }">
                              <CButton
                                color="secondary"
                                size="sm"
                                style="margin-top: 10px"
                                @click="verDetallesLote(item.id)"
                                >Ver detalles</CButton
                              >
                            </template>
                          </CDataTable>
                        </CCollapse>
                      </CCol></CRow
                    >
                  </CListGroupItem>
                </CListGroup>
                <CListGroup v-if="cargandoExpedientes">
                  <CListGroupItem
                    style="display: block !important; overflow-x: auto"
                    >Cargando expedientes</CListGroupItem
                  >
                </CListGroup>
                <CListGroup
                  v-if="
                    !cargandoExpedientes && concurso.expedientes.length == 0
                  "
                >
                  <CListGroupItem
                    style="display: block !important; overflow-x: auto"
                    >Sin expedientes</CListGroupItem
                  >
                </CListGroup>
              </CCard>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CModal title="Información" :show.sync="showEvento" size="sm" centered>
        <div v-html="mensajeEvento">{{ mensajeEvento }}</div>

        <template #footer>
          <CButton @click="showEvento = false" color="danger">Aceptar</CButton>
        </template>
      </CModal>

      <CModal title="Simulación del concurso" :show.sync="showEventoSimulacion" size="lg" centered>
        <div v-html="mensajeEvento">{{ mensajeEvento }}</div>

        <template #footer>
          <CButton @click="showEventoSimulacion = false" color="info">Aceptar</CButton>
        </template>
      </CModal>

      <CModal
        title="Información"
        :show.sync="calculando"
        :close-on-backdrop="false"
        size="sm"
        centered
      >
        <div v-html="mensajeEvento">{{ mensajeEvento }}</div>

        <template #footer>
          <div>
            
          </div>
          <CButton v-if="closed" @click="returnPage" color="info">Aceptar</CButton>
        </template>
        <template #header>
          <h5 style="margin-top: 10px">Información</h5>
        </template>
      </CModal>

      <CModal
        title="Simulación del concurso"
        :show.sync="simConcursoModal"
        :close-on-backdrop="false"
        size="lg"
        centered
      >
        <div>Se va a proceder a simular la resolución del concurso para detectar los lotes con empates significativos que puedan afectar a la resolución del mismo. 
          En caso de existir uno o más lotes con empates que necesitan atención se recomienda evitar cerrar o refrescar la página hasta haber resuelto los empates para evitar simular la resolución del concurso de nuevo.
        </div>

        <template #footer>
          <div>
            
          </div>
          <CButton @click="simConcurso" color="info">Simular resolución</CButton>
          <CButton @click="simConcursoModal = false" color="danger">Cancelar</CButton>
        </template>
        <template #header>
          <h5 style="margin-top: 10px">Información</h5>
        </template>
      </CModal>

      <CModal
        title="Cerrar concurso"
        :show.sync="showCerrarConcurso"
        size="lg"
        centered
      >
        <div>
          Se va a proceder a cerrar el concurso.
          <b>Esta tarea implica lo siguiente:</b><br /><br />
          <ul>
            <li>
              Se eliminará toda información relativa al concurso salvo su
              información más básica.
            </li>
            <li>
              No podrá volver a modificar nada relacionado con este concurso.
            </li>
            <li>
              Guarde en formato Excel, PDF o CSV los informes del concurso para
              consultarlos si es necesario antes de cerrar el concurso.
            </li>
          </ul>
          <b
            >Una vez que cierre el concurso avise al equipo de soporte para
            proceder con las tareas de borrado y copia de seguridad del
            concurso.</b
          >
        </div>
        <CInput
          label="Introduce la contraseña para confirmar la acción"
          placeholder="Contraseña"
          vertical
          style="margin-top: 25px"
          type="password"
          @input="handlePassword"
          autocomplete="curent-password"
        >
          <template #prepend-content><CIcon name="cil-lock-locked" /></template>
        </CInput>
        <template #footer>
          <CButton @click="closeConcurso" color="danger">Aceptar</CButton>
        </template>
      </CModal>
    </div>
  </div>
</template>

<style scoped>
.status-card {
  min-height: fit-content;
  height: calc(100% - 25px);
}

.status-card .card-body {
  align-items: unset !important;
}
</style>

<script>
import Cookies from "js-cookie";
import CustomExport from "../../utils/CustomExport";
import {
  getDetallesConcurso,
  getExpedientesConcurso,
  getDetallesExpediente,
  calcularBajas,
  resolverConcurso,
  cerrarConcurso,
  calcularPuntos,
  detectarEmpates,
  simularResolucion
} from "../../requests/concursos";
import { logOut } from "../../utils/authUtils";
import { getDetallesLote } from "../../requests/lotes";

export default {
  name: "ConsultarConcursos",
  components: {
    CustomExport,
  },
  created() {},
  mounted() {
    this.cargarInformacionConcurso();
  },
  data() {
    return {
      idConcurso: 0,
      concurso: {}, //objeto del concurso
      calculando: false, //muestra que está cargando
      closed: false, //si se ha cerrado el concurso
      segundos: 0,
      minutos: 0,
      empatesSignificativos: true,
      simConcursoModal: false,
      showEventoSimulacion: false,
      listaLotesEmpatados: [], //lista con los lotes que tienen empates
      listaLotesBajas: [], //lista de lotes con bajas
      listaLotesConIncidencias: [],
      camposLotesIncidencias: [
        {
          key: "nombreExpediente",
          field: "Expediente",
          label: "Expediente",
        },
        { key: "numero", field: "Número de lote", label: "Número de lote" },
        {
          key: "descripcionEstadoLote",
          field: "Estado",
          label: "Estado",
        },
        { key: "descripcion", field: "Descripción", label: "Descripción" },
        {
          key: "acciones",
          field: "Acciones",
          label: "Acciones",
        },
      ],
      cargandoExpedientes: true, //para mostrar una animacion de carga en la tabla
      listaConcursos: [],
      mensajeEvento: "",
      showEvento: false,
      showCerrarConcurso: false,
      contraseña: "",
      camposCritEval: [
        {
          key: "nombreCriterio",
          field: "Nombre del criterio",
          label: "Nombre del criterio",
        },
        { key: "peso", field: "Peso", label: "Peso" },
      ],
      camposSubexpediente: [
        { key: "numero", field: "Número de lote", label: "Número de lote" },
        { key: "codigoRuta", field: "Código ruta", label: "Código ruta" },
        {
          key: "nombreProvincias",
          field: "Provincia",
          label: "Provincia",
        },
        {
          key: "descripcionEstadoLote",
          field: "Estado",
          label: "Estado",
        },
        {
          key: "descripcionTipoLote",
          field: "Tipo del lote",
          label: "Tipo del lote",
        } /*
        {
          key: "descripcionTramoTarifario",
          field: "Tramo tarifario",
          label: "Tramo tarifario",
        },
        {
          key: "diasDicJun",
          field: "Dias DIC-JUN",
          label: "Dias DIC-JUN",
        },
        {
          key: "diasSeptNov",
          field: "Dias SEP-NOV",
          label: "Dias SEP-NOV",
        },
        {
          key: "km",
          field: "Kilómetros",
          label: "Kilómetros",
        },
        {
          key: "precioDiaSinIVA",
          field: "Precio día sin IVA",
          label: "Precio día sin IVA",
        },
        {
          key: "precioDiaConIVA",
          field: "Precio día con IVA",
          label: "Precio día con IVA",
        },
        {
          key: "presupuestoImpuestos",
          field: "Presupuesto impuesto",
          label: "Presupuesto impuesto",
        },
        {
          key: "presupuestoLicitacionSinIVA",
          field: "Presupuesto licitación sin IVA",
          label: "Presupuesto licitación sin IVA",
        },
        {
          key: "presupuestoLicitacionConIVA",
          field: "Presupuesto licitación con IVA",
          label: "Presupuesto licitación con IVA",
        },*/,
        {
          key: "valorContratoSinIVA",
          field: "Valor contrato",
          label: "Valor contrato",
        },
        { key: "acciones", label: "Acciones" },
      ],
      camposTabla: [
        { key: "nombre", field: "Nombre", label: "Nombre" },
        {
          key: "numeroExpediente",
          field: "Número de expediente",
          label: "Número de expediente",
        },
        {
          key: "ultimoCalculoBaja",
          field: "Cálculo de baja",
          label: "Cálculo de baja",
        },
        {
          key: "idEstadoConcurso",
          field: "Estado del concurso",
          label: "Estado del concurso",
        },
        { key: "acciones", label: "" },
      ],
      camposExportar: [
        "Nombre",
        "Número de expediente",
        "Cálculo de baja",
        "Estado del concurso",
      ],
    };
  },
  methods: {
    cargarInformacionConcurso() {
      this.idConcurso = this.$route.query.id;
      getDetallesConcurso(this.idConcurso)
        .then((res) => {
          res.data["expedientes"] = [];
          this.concurso = res.data;
          //console.log(this.concurso);

          this.listaLotesEmpatados = this.concurso.lotesConEmpates;
          this.listaLotesBajas = this.concurso.lotesBajasSinAnalizar;
          this.listaLotesConIncidencias = [];

          this.concurso.lotesConEmpates.forEach((idLote) => {
            getDetallesLote(idLote).then((lote) => {
              lote.data["descripcion"] = "Empate";
              this.listaLotesConIncidencias.push(lote.data);
            });
          });

          this.concurso.lotesBajasSinAnalizar.forEach((idLote) => {
            getDetallesLote(idLote.id).then((lote) => {
              //console.log(lote);
              lote.data["descripcion"] = "Bajas sin analizar";
              this.listaLotesConIncidencias.push(lote.data);
            });
          });

          getExpedientesConcurso(this.idConcurso).then((expedientes) => {
            let count = 0;
            if (expedientes.data.length == 0) this.cargandoExpedientes = false;
            expedientes.data.forEach((expediente) => {
              getDetallesExpediente(expediente.id).then(
                (detallesExpediente) => {
                  detallesExpediente["mostrarLotes"] = false;
                  this.concurso.expedientes.push(detallesExpediente.data);
                  count++;
                  if (count == expedientes.data.length) {
                    this.cargandoExpedientes = false;
                  }
                }
              );
            });
            //console.log(this.concurso);
          });
        })
        .catch((error) => {
          if (error.response.status == 403) logOut();
        });
    },
    formatDate(date) {
      let hora = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      let minutos =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();

      let dia = date.getDate();
      let mes = date.getMonth() + 1;
      let ano = date.getFullYear();

      return dia + "/" + mes + "/" + ano + " " + hora + ":" + minutos;
    },
    sumarSegundo() {
      if (this.calculando) {
        this.segundos++;
        if (this.segundos >= 60) {
          this.segundos = 0;
          this.minutos++;
        }
        let min = this.minutos > 9 ? this.minutos : "0" + this.minutos;
        let sec = this.segundos > 9 ? this.segundos : "0" + this.segundos;

        this.mensajeEvento =
          "Calculando información. Por favor, espere. <br><br><b>Tiempo transcurrido: " +
          min +
          ":" +
          sec +
          "</b>";
        setTimeout(this.sumarSegundo, 1000);
      } else {
        this.segundos = 0;
        this.minutos = 0;
      }
    },
    getBadge(situacion) {
      //console.log(situacion);
      switch (situacion) {
        case 0:
          return "warning";
        case 1:
          return "success";
        case 2:
          return "warning";
        case 3:
          return "warning";
        case 4:
          return "danger";
        case 5:
          return "danger";
        case 6:
          return "warning";
        default:
          return "warning";
      }
    },
    getBadgeLote(situacion) {
      switch (situacion) {
        case "Sin Asignar":
          return "danger";
        case "Asignado Pendiente Validar":
          return "info";
        case "Asignado Pendiente Desempate":
          return "warning";
        case "Asignado Validado":
          return "success";
        case "Adjudicado":
          return "success";
        case "Asignado Pendiente Subsanación":
          return "warning";
        case "Desistido o renunciado":
          return "danger";
        case "Desierto":
          return "danger";
        default:
          return "warning";
      }
    },
    getBadgeResolucion(idEstado) {
      //console.log(idEstado);
      switch (idEstado) {
        case "Cerrado":
          return "danger";
        case "Pendiente":
          return "warning";
        case "Abierto":
          return "info";
        case "En Resolución":
          return "success";
      }
    },
    returnPage() {
      this.$router.back();
    },
    mostrarLotes(subexpediente) {
      subexpediente.mostrarLotes = !subexpediente.mostrarLotes;
      this.$forceUpdate();
    },
    verDetallesLote(idLote) {
      this.$router.push({ path: "/lotes/detalle?id=" + idLote });
    },
    detectarBajas() {
      this.calculando = true;
      this.sumarSegundo();
      calcularBajas(this.idConcurso)
        .then((res) => {
          this.calculando = false;
          this.showEvento = true;
          this.mensajeEvento = "Bajas calculadas con éxito.";
          this.cargarInformacionConcurso();
        })
        .catch((error) => {
          this.calculando = false;
          this.showEvento = true;
          this.mensajeEvento =
            "No se han podido calcular las bajas correctamente. <br> Causa: <b>" +
            error.response.data.error +
            "</b>.";
        });
    },
    resConcurso() {
      this.calculando = true;
      this.sumarSegundo();
      resolverConcurso(this.idConcurso).then((res) => {
        this.calculando = false;
        this.showEvento = true;

        this.mensajeEvento =
          "Concurso resuelto. Se han asignado las ofertas con más puntos a sus correspondientes lotes.";
        this.cargarInformacionConcurso();
      });
    },
    simConcurso(){
      this.simConcursoModal = false;
      this.calculando = true;
      this.sumarSegundo();
      simularResolucion(this.idConcurso).then((res) => {
        this.calculando = false;
        this.showEventoSimulacion = true;
        let listaLotesEmpatesSignificativos = [];
        
        if(res.data.length > 0)
          this.mensajeEvento =
            `Simulación de la resolución del concurso completada.<br>Se han detectado empates significativos que necesitan resolución en los siguientes lotes:<br>`;
        else this.mensajeEvento =
              `Simulación de la resolución del concurso completada. No se han encontrado empates que requieran de resolución.`;

        res.data.forEach(loteId => {
          this.listaLotesConIncidencias.forEach(loteIncidencia => {
            if(loteIncidencia.id == loteId){
              listaLotesEmpatesSignificativos.push(loteIncidencia);
              loteIncidencia.descripcion = "Empate significativo";
              this.mensajeEvento += `<br> -<b>Expediente: </b>${loteIncidencia.nombreExpediente}, <b>Número de lote: </b>${loteIncidencia.numero}`
              }
            })
        })

        this.empatesSignificativos = listaLotesEmpatesSignificativos.length > 0; //si la lista de lotes con empates significativos esta vacia que muestre el boton de resolver
        console.log(this.empatesSignificativos)
      });
    },
    calcularPuntos() {
      this.calculando = true;
      this.sumarSegundo();
      calcularPuntos(this.idConcurso)
        .then((res) => {
          detectarEmpates(this.idConcurso)
            .then((res2) => {
              this.calculando = false;
              this.showEvento = true;
              this.mensajeEvento = "Puntuación calculada.";
              this.cargarInformacionConcurso();
            })
            .catch((error) => {
              this.calculando = false;
              this.showEvento = true;
              this.mensajeEvento =
                "No se han podido detectar los empates correctamente. <br> Causa: <b>" +
                error.response.data.error +
                "</b>.";
            });
        })
        .catch((error) => {
          this.showEvento = true;
          this.mensajeEvento =
            "No se han podido calcular los puntos correctamente. <br> Causa: <b>" +
            error.response.data.error +
            "</b>.";
        });
    },
    closeConcurso() {
      this.showCerrarConcurso = false;
      cerrarConcurso(this.idConcurso, this.contraseña)
        .then((res) => {
          this.calculando = true;
          this.closed = true;
          //console.log(this.closed);
          this.mensajeEvento = "Concurso cerrado correctamente.";
        })
        .catch((error) => {
          this.showEvento = true;
          this.mensajeEvento =
            "No se han podido cerrar el concurso. <br> Causa: <b>" +
            error.response.data.error +
            "</b>.";
        });
    },
    handlePassword(value){
      this.contraseña = value;
    }
  },
  beforeDestroy() {},
};
</script>
